module.exports = __webpack_public_path__ + "img/oneday1-3.d9bec32d.jpg";